export class LogoutCancelledError extends Error {
  constructor(message = 'User cancelled logout to preserve unsaved draft') {
    super(message);
    this.name = 'LogoutCancelledError';
  }
}
